export const POSITIONCHANGE_LOADING = "POSITIONCHANGE_LOADING";
export const POSITIONCHANGE_RESET = "POSITIONCHANGE_RESET";
export const GET_POSITIONCHANGE = "GET_POSITIONCHANGE";
export const GET_POSITIONCHANGE_SUCCESS = "GET_POSITIONCHANGE_SUCCESS";
export const GET_POSITIONCHANGE_FAIL = "GET_POSITIONCHANGE_FAIL";
export const DELETE_POSITIONCHANGE = "DELETE_POSITIONCHANGE"
export const DELETE_POSITIONCHANGE_SUCCESS = "DELETE_POSITIONCHANGE_SUCCESS"
export const DELETE_POSITIONCHANGE_FAIL = "DELETE_POSITIONCHANGE_FAIL"
export const UPDATE_POSITIONCHANGE = "UPDATE_POSITIONCHANGE"
export const UPDATE_POSITIONCHANGE_SUCCESS = "UPDATE_POSITIONCHANGE_SUCCESS"
export const UPDATE_POSITIONCHANGE_FAIL = "UPDATE_POSITIONCHANGE_FAIL"
export const ADD_NEW_POSITIONCHANGE = "ADD_NEW_POSITIONCHANGE"
export const ADD_POSITIONCHANGE_SUCCESS = "ADD_POSITIONCHANGE_SUCCESS"
export const ADD_POSITIONCHANGE_FAIL = "ADD_POSITIONCHANGE_FAIL"